import apiClient from './api';
import axios from 'axios';
import config from '../config';

// Önbellek mekanizması
const cache = {
  accommodations: null
};

// Hata loglama yardımcı fonksiyonu
const logError = (error) => {
  console.error('Error in accommodationService:', error.message);
  if (error.response) {
    console.error('Status:', error.response.status);
    console.error('Data:', error.response.data);
  }
};

export const accommodationService = {
  async getAccommodations() {
    // Önbellekte varsa, önbellekten getir
    if (cache.accommodations) {
      console.log('Using cached accommodations data');
      return cache.accommodations;
    }
    
    try {
      
      // Kullanıcı token'ını al
      const userData = JSON.parse(localStorage.getItem('user_data'));
      const token = userData?.token;
      
      // Yönlendirmeleri takip etmek için doğrudan axios kullanıyoruz
      const response = await axios.get(`${config.API_BASE_URL_V1}accommodations`, {
        maxRedirects: 5, // Maksimum 5 yönlendirmeye izin ver
        headers: {
          'Content-Type': 'application/json',
          'Authorization': token ? `Bearer ${token}` : ''
        },
        withCredentials: true // CORS ile ilgili çerezleri gönder
      });
      
      const data = response.data.data;
      
      // Sonucu önbelleğe kaydet
      cache.accommodations = data;
      
      return data;
    } catch (error) {
      logError(error);
      throw error;
    }
  },
  
  // Önbelleği temizleme
  clearCache() {
    cache.accommodations = null;
    console.log('Accommodation service cache cleared');
  }
};

export default accommodationService; 